<template>
  <div>
    <mu-stepper :activeStep="2">
      <mu-step>
        <mu-step-label>
          {{$t('message.gettingStartedTabYou')}}
        </mu-step-label>
      </mu-step>
      <mu-step>
        <mu-step-label>
          {{$t('message.gettingStartedTabHealth')}}
        </mu-step-label>
      </mu-step>
      <mu-step>
        <mu-step-label>
          {{$t('message.gettingStartedTabLocation')}}
        </mu-step-label>
      </mu-step>
      <mu-step>
        <mu-step-label>
          {{$t('message.gettingStartedTabGoals')}}
        </mu-step-label>
      </mu-step>
      <mu-step>
        <mu-step-label>
          {{$t('message.gettingStartedTabPersonalise')}}
        </mu-step-label>
      </mu-step>
    </mu-stepper>
    <mu-card align="left">
      <div v-if="isLoading">
        <mu-card-text align="center">
          <img src="static/Dashboard.gif" width="25%"/>
          <br/>
          Loading...
        </mu-card-text>
      </div>
      <div v-show="!isLoading">
        <mu-card-header
          :title="title"
          :subTitle="subTitle"
        ></mu-card-header>
        <mu-card-text>
          <mu-row gutter>
            <mu-col width="100" desktop="70" tablet="100">
              <mu-row gutter>
                <mu-col width="100" desktop="70" tablet="60">
                  <mu-select-field
                    :scroller="scroller"
                    v-validate
                    :data-vv-rules="'required'"
                    data-vv-name="country"
                    data-vv-value-path="inputValue"
                    data-vv-as="country"
                    :errorText="errors.first('relationship')"
                    :underlineShow="underlineShow"
                    :fullWidth="fullWidth"
                    :maxHeight="300"
                    hintText="Select"
                    v-model="model.country_id"
                    :label="$t('message.addressCountry')">
                    <mu-menu-item
                      v-for="item, index in lists.countries"
                      :key="'country-'  + index"
                      :value="item.country_id"
                      :title="localizeCountry(item.alpha3_code)"
                    >
                    </mu-menu-item>
                  </mu-select-field>
                </mu-col>
                <mu-col width="100" desktop="30" tablet="40">
                  <mu-text-field
                    id="postcodeTxt"
                    :fullWidth="fullWidth" v-if="model.country_id === 235 || model.country_id === 237"
                    :label="$t('message.addressPostcode')"
                    v-model="model.postcode"
                    hintText="Post code"></mu-text-field>
                </mu-col>
              </mu-row>
              <div id="surgery" v-show="model.country_id === 235">
                <mu-auto-complete
                  :scroller="scroller"
                  inputClass="surgerySearchTxt"
                  v-model="surgerySearchValue"
                  :maxHeight="250"
                  :openOnFocus="true"
                  :label="$t('message.gettingStartedLocationGpSurgery')"
                  :fullWidth="fullWidth"
                  :hintText="$t('message.searchText')" filter="noFilter"
                  :dataSource="surgeries"
                  :dataSourceConfig="dataSourceConfig"
                  @change="handleSurgerySelected"
                ></mu-auto-complete>
              </div>
              <div v-if="activeSurgery.surgery_name">
                <mu-raised-button backgroundColor="#D5D5D5" color="#444" @click.native="clearSurgery" label="Clear"
                                  icon="clear"></mu-raised-button>

              </div>
              <mu-checkbox v-if="!activeSurgery.surgery_name" v-show="model.country_id === 235"
                           v-model="unableToFindSurgery" :label="$t('message.gettingStartedLocationSurgeryNotInList')"></mu-checkbox>
              <mu-row v-if="unableToFindSurgery" :gutter="true">
                <mu-col desktop="50" tablet="50" width="100">
                  <mu-text-field
                    v-validate
                    :data-vv-rules="'required'"
                    data-vv-name="surgery"
                    data-vv-value-path="inputValue"
                    data-vv-as="surgery"
                    :errorText="errors.first('surgery')"
                    :fullWidth="fullWidth"
                    :hintText="$t('message.addressSurgeryName')"
                    v-model="model.surgery.surgery_name"
                  />
                  <br/>
                  <mu-text-field
                    v-validate
                    :data-vv-rules="'required'"
                    data-vv-name="address_line_1"
                    data-vv-value-path="inputValue"
                    :data-vv-as="$t('message.addressLine1')"
                    :errorText="errors.first('address_line_1')"
                    :fullWidth="fullWidth"
                    :hintText="$t('message.addressLine1')"
                    v-model="model.surgery.address_line_1"
                  />
                  <br/>
                  <mu-text-field
                    :fullWidth="fullWidth"
                    :hintText="$t('message.addressLine2')"
                    v-model="model.surgery.address_line_2"
                  />
                  <br/>
                </mu-col>
                <mu-col desktop="50" tablet="50" width="100">
                  <mu-text-field
                    v-validate
                    :data-vv-rules="'required'"
                    data-vv-name="surgery_postcode"
                    data-vv-value-path="inputValue"
                    :data-vv-as="$t('message.addressPostcode')"
                    :errorText="errors.first('surgery_postcode')"
                    :fullWidth="fullWidth"
                    :hintText="$t('message.addressPostcode')"
                    v-model="model.surgery.postcode"
                  />
                  <mu-text-field
                    v-validate
                    :data-vv-rules="'required'"
                    data-vv-name="surgery_city"
                    data-vv-value-path="inputValue"
                    :data-vv-as="$t('message.addressCity')"
                    :errorText="errors.first('surgery_city')"
                    :fullWidth="fullWidth"
                    :hintText="$t('message.addressCity')"
                    v-model="model.surgery.city"
                  />
                  <mu-text-field
                    :fullWidth="fullWidth"
                    :hintText="$t('message.addressCounty')"
                    v-model="model.surgery.county"
                  />
                </mu-col>
              </mu-row>
            </mu-col>
          </mu-row>
          <br/>
          <mu-raised-button
            id="submitBtn"
            :fullWidth="true"
            secondary
            :disabled="isSaving"
            @click.native="submitForm"
            :label="isSaving ? $t('message.savingText'): $t('message.nextText')"></mu-raised-button>
        </mu-card-text>
      </div>
    </mu-card>
  </div>
</template>
<script>






  import CountryLocalizerMixin from '../../mixins/Localization/Countries'



  import AccountApi from '../../api/Account'
  import SurgeryApi from '../../api/Surgery'
  import UserApi from '../../api/User'

  import ScrollerMixin from '../../mixins/ScrollerMixin'


  import {Observable} from 'rxjs/Rx'

  let dataSourceConfig = {
    text: 'surgery_name',
    value: 'surgery_id'
  }
  export default {
    name: 'location',
    mixins: [ScrollerMixin, CountryLocalizerMixin],
    data() {
      return {
        title: this.$t('message.gettingStartedLocationTitle'),
        subTitle: this.$t('message.gettingStartedLocationSubTitle'),
        activeDiabetesType: {},
        activeSurgery: {},
        isLoading: true,
        isSaving: false,
        isDiabetic: true,
        activeStep: 1,
        fullWidth: true,
        underlineShow: true,
        unableToFindSurgery: false,
        model: {
          country_id: null,
          postcode: null,
          diabetes_type_id: null,
          surgery_id: null,
          surgery: {}
        },
        lists: {},
        surgerySearchValue: '',
        surgeries: [],
        dataSourceConfig: dataSourceConfig
      }
    },
    watch: {
      'model.country_id': function () {
        let self = this;
        self.$nextTick(function () {
          self.$forceUpdate();
        })

      },
      'model.diabetes_type_id': function (newValue, oldValue) {
        let self = this;
        if (newValue != null) {
          self.activeDiabetesType = self.lists.diabetes_types.filter(function (type) {
            return type.diabetes_type_id === newValue
          })[0];
          if (_.has(self.activeDiabetesType, 'is_diabetic')) {
            if (self.activeDiabetesType.is_diabetic === true) {
              self.isDiabetic = true;
              self.activeStep = 2
            }
            else {
              self.isDiabetic = false;
              self.activeStep = 1
            }
          }
          self.$forceUpdate();
        }
      }
    },
    mounted() {
      let self = this;

      self.$gtag.pageview('/getting-started/location');

      Observable.fromEvent($('.surgerySearchTxt'), 'input').map(x => x.currentTarget.value)
        .debounceTime(100).distinctUntilChanged()
        .subscribe(function (eventText) {
          self.handleSurgerySearch(eventText)
        });
      let countryId = 235;
      if (_.has(self.$store.state.geoLocation, 'country_id')) {
        countryId = self.$store.state.geoLocation.country_id;
        if (countryId === 0) {
          self.model.country_id = 235;
        }
        else {
          self.model.country_id = countryId;
        }
      }
      self.lists = self.$store.state.list;






      AccountApi.getAccount()
        .then(function (response) {
          //self.model.country_id = countryId;
          self.model.diabetes_type_id = response.data.diabetes_type_id;
          self.model.postcode = response.data.postcode_zip;
          if (self.model.diabetes_type_id === 0) {
            self.model.diabetes_type_id = null
          }
          self.isLoading = false;
          self.$nextTick(function () {
            self.errors.clear()
          })
        })
        .catch(function (error) {
          window.location.href = '../login/'
        })
    },
    methods: {
      submitForm() {
        let self = this;
        self.$validator.validateAll()
          .then(function (valid) {
            if (valid === true) {
              self.isSaving = true;
              AccountApi.putUserLocation(self.model)
                .then(function (response) {
                  UserApi.onBoardingStatus()
                    .then(function (response) {
                      self.$store.commit('setOnBoardingStatus', response.data);
                      self.$router.push({
                        name: 'GettingStartedGoals'
                      })
                    });
                })
                .catch(function (error) {
                  self.isSaving = false
                })
            }
          })
          .catch(function () {
            self.isSaving = false;
          })
      },
      forceUpdate() {
        let self = this;
        self.$forceUpdate()
      },
      handleSurgerySelected(value) {
        let self = this;
        let object = (
          self.surgeries.filter(function (surgery) {
            return surgery.surgery_name === value
          })
        )[0];
        self.activeSurgery = object;
        self.model.surgery_id = object.surgery_id
      },
      handleSurgerySearch(filter) {
        let self = this;
        SurgeryApi.searchSurgeriesByQuery(filter)
          .then(function (response) {
            let surgeryLength = response.data.surgeries.length
            for (let i = 0; i < surgeryLength; i++) {
              response.data.surgeries[i].surgery_name += ', ' + response.data.surgeries[i].address_line_2 + ', ' + response.data.surgeries[i].postcode
            }
            self.surgeries = response.data.surgeries
          })
      },
      clearSurgery() {
        let self = this;
        self.model.surgery_id = null;
        self.surgerySearchValue = '';
        self.activeSurgery = {};
        self.surgeries = [];
        $('#surgery .mu-auto-complete .mu-text-field-input').focus()
      }
    }
  }
</script>
<style>
  .mu-text-field-help {
    position: static !important;
  }

  .noPaddingTop {
    padding-top: 0px !important;
  }

  .noPaddingBottom {
    padding-bottom: 0px !important;
  }
</style>



// WEBPACK FOOTER //
// Location.vue?6f3078c8